{
  "moduleTitle": "Select a Module",
  "detailsTitle": "Assignment Details",
  "continue": "Continue",
  "assign": "Assign module",
  "assigning": "Assigning",
  "missingContext": "Missing the context needed to assign this Module. Please refresh and try again.",
  "retry": "Retry",
  "emptyTitle": "No Modules Yet",
  "emptyMessage": "Create a Training Module before assigning one.",
  "alreadyAssigned": "Already assigned",
  "reassignWarning": "Assigning this Module again will remove {{person}}'s existing progress.",
  "dueDate": "Due Date",
  "notify": "Notify me when {{person}} finishes this Module"
}
